import { NgModule } from '@angular/core';
import { ProcessingQuestionnaireComponent } from './processing-questionnaire/processing-questionnaire.component';
import { SummaryQuestionnaireComponent } from './summary-questionnaire/summary-questionnaire.component';
import { MappingQuestionnaireComponent } from './maping-questionnaire/mapping-questionnaire.component';
import { UploadQuestionnaireComponent } from './upload-questionnaire/upload-questionnaire.component';
import { QuestionnaireComponent } from './questionnaire.component';
import { SharedModule } from '@shared/shared.module';
import { MappingWorksheetComponent } from './maping-questionnaire/maping-worksheet/mapping-worksheet.component';

const components = [
  QuestionnaireComponent,
  UploadQuestionnaireComponent,
  MappingQuestionnaireComponent,
  MappingWorksheetComponent,
  SummaryQuestionnaireComponent,
  ProcessingQuestionnaireComponent,
];

@NgModule({
  declarations: components,
  imports: [SharedModule],
  exports: [...components],
})
export class QuestionnaireModule {}
